export default "__VITE_PUBLIC_ASSET__312a527e__"